import api from "./API";
import { Transaction } from "../Types/Transaction";
import { AccountBalance } from "../Types/Balance";

export async function getSettledTransactions(from: Date, to: Date): Promise<Transaction[]> {
    try {
        const response = await api.get(`/api/account/get/transactions`, {
            headers: {
                "dateFrom": from.toISOString(),
                "dateTo": to.toISOString(),
            },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getTransaction(feedItemUid: string, categoryUid: string): Promise<Transaction> {
    try {
        const response = await api.get(`/api/account/get/transaction/${categoryUid}/${feedItemUid}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getAccountBalance(): Promise<AccountBalance> {
    try {
        const response = await api.get("/api/account/get/balance");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function putTransactionNote(feedItemUid: string, categoryUid: string, note: string): Promise<void> {
    try {
        await api.put(`/api/account/put/note/${categoryUid}/${feedItemUid}`, { note });
    } catch (error) {
        console.error(error);
        throw error;
    }
}